import moment from 'moment';

export const checkIsEquel = (firstDate: string, secondDate: string): boolean => {
    const first = moment(firstDate);
    const second = moment(secondDate);
    return first.diff(second) === 0;
};
